import { OfferState } from "./offerState";
import { OfferRequestCallOffInterval } from "./offerRequestCallOffInterval";
import { OfferRequestPositionDto } from "./offerRequestPositionDto";

/**
 * A request for an individually calculated offer covering large quantities,
 * recurring series or project work. Unlike the automatic offer created in the
 * cart, an offer request is reviewed by a person at Blexon.
 *
 * The request carries its own positions. They are copied from the cart once, when
 * the request is created, and are edited independently from that point on.
 */
export class OfferRequestDto {
	public id: number = 0;
	/** Title the customer gave the request. May be empty. */
	public title: string = "";
	public state: OfferState = OfferState.Draft;
	public createdAt: Date = new Date();
	/** Articles and quantities the offer is requested for. */
	public positions: OfferRequestPositionDto[] = new Array<OfferRequestPositionDto>();

	/**
	 * Start of the requested completion window. For a recurring request the window
	 * refers to the first delivery.
	 */
	public completionFrom: Date | null = null;
	/** End of the requested completion window. See completionFrom. */
	public completionTo: Date | null = null;
	/** Rhythm in which the demand comes up. Once means a single order. */
	public callOffInterval: OfferRequestCallOffInterval = OfferRequestCallOffInterval.Once;
	/**
	 * How many intervals lie between two call-offs, so 1 means every week or every
	 * month. Always 1 for a single order and for a yearly rhythm.
	 */
	public callOffIntervalCount: number = 1;

	/**
	 * Chosen delivery address. Null means the customer collects the order, so no
	 * separate delivery type is needed.
	 */
	public deliveryAddressId: number | null = null;
	/** Free text about delivery or collection, e.g. partial deliveries or time windows. */
	public deliveryNote: string = "";

	/**
	 * Whether a first article inspection is requested at all. Which positions are
	 * sampled and in what quantity is carried by the positions themselves.
	 */
	public wantsFirstArticleInspection: boolean = false;

	/** Free text with anything else that matters for the calculation. */
	public remarks: string = "";
}
